'use client';
import LazyLoad, { LazyLoadProps } from 'react-lazyload';

interface ImageProps extends LazyLoadProps {
  className?: string;
  imgComponent?: any; //todo better type for this
  style?: {
    height?: string;
    width?: string;
  };
}

const LazyLoadImage = ({ className, imgComponent, style }: ImageProps) => {
  return (
    <LazyLoad once offset={500} className={className} style={style}>
      <img {...imgComponent.props} />
    </LazyLoad>
  );
};

export default LazyLoadImage;
